export const ENV = process.env.NODE_ENV;
export const IS_DEV = ENV === 'development';
export const IS_PROD = ENV === 'production';
export const API_BASE = process.env.REACT_APP_API_BASE;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const LANG = process.env.REACT_APP_LANG;
